<template>
    <div class="course-detail-page">
        <!-- 公共头部 -->
        <HeaderPc />

        <!-- 课程标题栏 -->
        <div class="course-title-bar">
            <div class="container">
                <!-- 纯视频课程标题栏 -->
                <div class="title-bar-content" v-if="courseType === 'video'">
                    <div class="title-left">
                        <h1 class="main-title">{{ courseInfo.name || '-' }}</h1>
                        <div class="course-meta-group">
                            <span class="meta-item"><i class="el-icon-user"></i> 讲师：{{ author.name || '-' }}</span>
                            <span class="meta-item"><i class="el-icon-s-data"></i> 收藏人数：{{ courseInfo.collect_count || 0 }}人</span>
                            <span class="meta-item"><i class="el-icon-user-solid"></i> 观看人数：{{ courseInfo.looks || 0 }}人</span>
                            <span class="meta-item"><i class="el-icon-video-play"></i> 课程类型：视频课程</span>
                            <span class="meta-item vip-tag" v-if="courseInfo.is_free != 1 && !courseInfo.is_buy" >
                                <span v-if="courseInfo.is_preview "><i class="el-icon-warning"></i> 付费课程仅支持试看<span v-if="courseInfo.preview_hours">{{ courseInfo.preview_hours || 0 }}小时</span><span v-if="courseInfo.preview_mins">{{ courseInfo.preview_mins || 0 }}分钟</span><span v-if="courseInfo.preview_seconds">{{ courseInfo.preview_seconds || 0 }}秒</span></span>
                                <span v-else><i class="el-icon-warning"></i> 付费课程需要购买后才可以观看</span>
                            </span>
                        </div>
                    </div>
                    <div class="title-right">
                        <el-button @click="toggleCollect" :type="courseInfo.is_collect ? 'warning' : 'default'" size="medium">
                            <i :class="courseInfo.is_collect ? 'el-icon-star-on' : 'el-icon-star-off'"></i> {{ courseInfo.is_collect ? '已收藏' : '收藏' }}
                        </el-button>
                        <el-button type="primary" size="medium" @click="goVipPage" v-if="courseInfo.is_free != 1 && !courseInfo.is_buy">
                            <i class="el-icon-shopping-cart-2"></i> 购买课程
                        </el-button>
                    </div>
                </div>

                <!-- 纯资料课程标题栏 -->
                <div class="title-bar-content" v-else>
                    <div class="title-left">
                        <h1 class="main-title">{{ courseInfo.name }}</h1>
                        <div class="course-meta-group">
                            <span class="meta-item"><i class="el-icon-folder-opened"></i> 文件数量：{{ classList.length }}个</span>
                            <span class="meta-item"><i class="el-icon-download"></i> {{ (courseInfo.is_free != 1 && !courseInfo.is_buy) ? '支持下载/预览' : '付费后下载' }}</span>
                            <span class="meta-item"><i class="el-icon-document"></i> 课程类型：资料课程</span>
                            <span class="meta-item vip-tag" v-if="courseInfo.is_free != 1 && !courseInfo.is_buy">
                                <i class="el-icon-warning"></i> 付费课程需要购买后才可以下载
                            </span>
                        </div>
                    </div>
                    <div class="title-right">
                        <el-button @click="toggleCollect" :type="courseInfo.is_collect ? 'warning' : 'default'" size="medium">
                            <i :class="courseInfo.is_collect ? 'el-icon-star-on' : 'el-icon-star-off'"></i> {{ courseInfo.is_collect ? '已收藏' : '收藏' }}
                        </el-button>
                        <el-button type="primary" size="medium" @click="goVipPage" v-if="courseInfo.is_free != 1 && !courseInfo.is_buy">
                            <i class="el-icon-shopping-cart-2"></i> 购买课程
                        </el-button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 主体内容 -->
        <main class="course-main">
            <div class="container">
                <!-- 纯视频课程 -->
                <div class="video-course-wrap" v-if="courseType === 'video'">
                    <!-- 视频播放区域 -->
                    <div class="video-player-section" :class="playerSize" v-if="classList && classList.length > 0">
                        <div class="video-player">
                            <!-- 视频播放组件（优化版） -->
                            <div class="video-container">
                                <video
                                    v-if="currentVideo.urls"
                                    ref="videoPlayer"
                                    class="video-core"
                                    :src="resourceUrl + currentVideo.urls"
                                    :poster="courseInfo.cover ? resourceUrl + courseInfo.cover : ''"
                                    controlsList="nodownload nofullscreen"
                                    @timeupdate="handleTimeUpdate"
                                    @loadedmetadata="handleLoadedMetadata"
                                    @pause="videoPaused = true"
                                    @play="videoPaused = false"
                                ></video>
                                
                                <!-- 自定义视频控制栏（优化版：新增手机观看按钮） -->
                                <div class="video-controls">
                                    <!-- 播放/暂停按钮 -->
                                    <button class="control-btn play-btn" @click="toggleVideoPlay">
                                        <i class="fa fa-play" v-if="videoPaused"></i>
                                        <i class="el-icon-video-pause" v-else></i>
                                    </button>

                                    <!-- 进度条 -->
                                    <div class="progress-wrap">
                                        <div 
                                            class="progress-bar"
                                            @click="handleProgressClick"
                                        >
                                            <div class="progress-loaded" :style="{ width: loadedPercent + '%' }"></div>
                                            <div class="progress-current" :style="{ width: currentPercent + '%' }"></div>
                                            <div class="progress-dot" :style="{ left: currentPercent + '%' }"></div>
                                        </div>
                                        <div class="time-wrap">
                                            <span>{{ formatTime(currentTime) }}</span>
                                            <span>/ {{ formatTime(totalTime) }}</span>
                                        </div>
                                    </div>

                                    <!-- 倍速 + 音量 + 手机观看 + 全屏按钮 -->
                                    <div class="control-group">
                                        <!-- 倍速选择 -->
                                        <button class="control-btn speed-btn" @click="showSpeedOptions = !showSpeedOptions">
                                            <span class="speed-text">{{ playbackSpeed }}x</span>
                                            <div class="speed-options" v-show="showSpeedOptions" @mouseleave="showSpeedOptions = false">
                                                <div 
                                                    class="speed-option"
                                                    v-for="speed in speedOptions"
                                                    :key="speed"
                                                    :class="{ active: playbackSpeed === speed }"
                                                    @click.stop="setPlaybackSpeed(speed)"
                                                >
                                                    {{ speed }}x
                                                </div>
                                            </div>
                                        </button>

                                        <!-- 音量控制 -->
                                        <button class="control-btn volume-btn" @click="toggleMute" title="音量">
                                            <i class="fa fa-volume-up" v-if="!isMuted"></i>
                                            <i class="fa fa-volume-mute" v-else></i>
                                        </button>

                                        <!-- 小窗按钮 -->
                                        <button class="control-btn small-btn" @click="togglePictureInPicture" title="画中画" v-if="!isFullscreen">
                                            <i class="el-icon-copy-document"></i>
                                        </button>

                                        <!-- 普通按钮 -->
                                        <button class="control-btn normal-btn" @click="playerSize = 'normal'" title="普通模式" v-if="!isFullscreen && playerSize !== 'normal'">
                                            <i class="el-icon-s-grid"></i>
                                        </button>

                                        <!-- 宽屏按钮 -->
                                        <button class="control-btn wide-btn" @click="playerSize = 'wide'" title="宽屏模式" v-if="!isFullscreen && playerSize !== 'wide'">
                                            <i class="el-icon-rank"></i>
                                        </button>

                                        <!-- 全屏按钮 -->
                                        <button class="control-btn fullscreen-btn" @click="toggleFullscreen" title="全屏">
                                            <i class="el-icon-full-screen" v-if="!isFullscreen"></i>
                                            <i class="fa fa-compress-arrows-alt" v-else></i>
                                        </button>

                                        <!-- 手机观看按钮 -->
                                        <button 
                                            class="control-btn phone-btn" 
                                            @mouseenter="showQrCode = true" 
                                            @mouseleave="showQrCode = false"
                                            title="手机继续观看"
                                        >
                                            <i class="el-icon-mobile-phone"></i>
                                        </button>
                                    </div>
                                </div>

                                <!-- 手机继续观看二维码（优化：仅移入手机按钮时显示） -->
                                <div class="qr-code-layer" v-show="showQrCode">
                                    <div class="qr-card">
                                        <div class="qr-header">
                                            <i class="el-icon-mobile-phone"></i>
                                            <span>手机继续观看</span>
                                        </div>
                                        <img 
                                            :src="currentVideo.qrcode ? (resourceUrl + currentVideo.qrcode + '?t=' + Date.now()) : ''" 
                                            alt="手机扫码继续学习" 
                                            class="qr-img"
                                            @error="handleQrError"
                                        >
                                        <p class="qr-tip">扫码后同步学习进度</p>
                                    </div>
                                </div>

                                <!-- 试看结束遮罩（优化图标显示） -->
                                <div class="watch-limit-mask" v-if="watchLimitReached">
                                    <div class="limit-card">
                                        <i class="el-icon-vip"></i>
                                        <h3>试看时间已结束</h3>
                                        <p>购买课程后即可观看完整课程内容</p>
                                        <el-button type="primary" size="medium" @click="goVipPage">立即购买</el-button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="video-list" v-show="playerSize === 'normal'">
                            <h3 class="list-title">视频章节 <span class="count">({{ classList.length }}课时)</span></h3>
                            <!-- 空状态展示 -->
                            <div class="empty-state" v-if="!classList || classList.length === 0">
                                <i class="el-icon-video-camera-solid"></i>
                                <p>暂无视频章节</p>
                            </div>
                            <!-- 视频列表 -->
                            <div 
                                class="video-item" 
                                v-for="(item, index) in classList" 
                                :key="item.id"
                                :class="{ active: currentVideo.id === item.id }"
                                @click="switchVideo(item)"
                            >
                                <span class="video-index">{{ index + 1 }}</span>
                                <span class="video-name" :title="item.name">{{ item.name || '' }}</span>
                                <span class="try-watch-tag" v-if="courseInfo.is_free != 1 && !courseInfo.is_buy">试看</span>
                                <span class="video-duration">{{ item.duration }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- 视频课程Tab页 + 推荐侧边栏（三栏布局） -->
                    <div class="course-info-section">
                        <el-tabs v-model="activeTab" class="course-tabs">
                            <el-tab-pane label="课程介绍" name="intro">
                                <div class="tab-content intro-content">
                                    <h3 class="content-title">课程详情</h3>
                                    <!-- 空状态展示 -->
                                    <div class="empty-state" v-if="!courseInfo.name && !courseInfo.desc">
                                        <i class="el-icon-document"></i>
                                        <p>暂无课程介绍</p>
                                    </div>
                                    <!-- 课程详情 -->
                                    <template v-else>
                                        <div class="intro-main">
                                            <div class="intro-left">
                                                <img :src="resourceUrl + courseInfo.cover" alt="课程封面" class="course-cover" @error="handleCoverError">
                                            </div>
                                            <div class="intro-right">
                                                <p><strong>讲师介绍：</strong>{{ author.desc || author.name || '暂无' }}</p>
                                                <p><strong>课程分类：</strong>{{ courseInfo.category_full_name || '暂无' }}</p>
                                                <p><strong>观看人数：</strong>{{ courseInfo.looks || 0 }}人</p>
                                                <p><strong>收藏人数：</strong>{{ courseInfo.collect_count || 0 }}人</p>
                                            </div>
                                        </div>
                                        <div class="intro-desc">
                                            <h4>课程简介</h4>
                                            <p v-html="courseInfo.describe || '暂无课程简介'"></p>
                                        </div>
                                    </template>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="章节列表" name="chapter">
                                <div class="tab-content chapter-content">
                                    <!-- 空状态展示 -->
                                    <div class="empty-state" v-if="!chapterList || chapterList.length === 0">
                                        <i class="el-icon-folder-opened"></i>
                                        <p>暂无章节列表</p>
                                    </div>
                                    <!-- 章节列表 -->
                                    <el-collapse v-else :value="[chapterList[0]?.id]">
                                        <el-collapse-item 
                                            v-for="(chapter, index) in chapterList" 
                                            :key="chapter.id"
                                            :name="chapter.id"
                                            :title="`第${index + 1}章：${chapter.name} (${chapter.lessons.length}课时)`"
                                        >
                                            <div 
                                                class="chapter-item" 
                                                v-for="(lesson, lessonIndex) in chapter.lessons" 
                                                :key="lesson.id"
                                                :class="{ 'active-lesson': currentVideo.id === lesson.videoId }"
                                                @click="playLessonVideo(lesson.videoId)"
                                            >
                                                <i class="el-icon-video-play"></i>
                                                <span class="lesson-name">{{ lessonIndex + 1 }}. {{ lesson.name }}</span>
                                            </div>
                                        </el-collapse-item>
                                    </el-collapse>
                                </div>
                            </el-tab-pane>
                        </el-tabs>

                        <!-- 恢复课程推荐侧边栏 -->
                        <div class="recommend-sidebar">
                            <h3 class="recommend-title">
                                <i class="el-icon-star-on"></i> 相关课程推荐
                            </h3>
                            <!-- 空状态 -->
                            <div class="empty-state" v-if="!recommendCourses || recommendCourses.length === 0">
                                <i class="el-icon-star-off"></i>
                                <p>暂无推荐课程</p>
                            </div>
                            <!-- 推荐列表 -->
                            <div 
                                class="recommend-item" 
                                v-for="item in recommendCourses" 
                                :key="item.id"
                                @click="goCourseDetail(item.id)"
                            >
                                <img 
                                    :src="resourceUrl + item.cover" 
                                    :alt="item.name" 
                                    class="recommend-cover"
                                    @error="handleCoverError($event)"
                                >
                                <div class="recommend-info">
                                    <h4 class="recommend-name" :title="item.name">{{ item.name || '-' }}</h4>
                                    <p class="recommend-teacher">讲师：{{ item.author_name || '-' }}</p>
                                    <div class="recommend-stats">
                                        <span><i class="el-icon-user"></i> {{ item.looks || 0 }}人</span>
                                        <span><i class="el-icon-star-on"></i> {{ item.collect_count || 0 }}</span>
                                    </div>
                                </div>
                            </div>
                            <el-button type="text" class="more-btn" @click="goRecommendList">查看更多 ></el-button>
                        </div>
                    </div>
                </div>

                <!-- 纯资料课程（保留推荐） -->
                <div class="file-course-wrap" v-else>
                    <div class="file-course-content">
                        <!-- 左侧：资料列表 + 预览/下载 -->
                        <div class="file-left">
                            <div class="file-header">
                                <h3 class="file-title">资料文件列表 <span class="count">({{ classList.length }}个)</span></h3>
                                <el-button v-if="!isVip" type="primary" size="small" @click="goVipPage">
                                    <i class="el-icon-shopping-cart-2"></i> 购买课程
                                </el-button>
                            </div>
                            <div class="file-list">
                                <div 
                                    class="file-item" 
                                    v-for="file in classList" 
                                    :key="file.id"
                                    @click="handleFileClick(file)"
                                >
                                    <i :class="getFileIcon(file.type)"></i>
                                    <span class="file-name" :title="file.name">{{ file.name }}</span>
                                    <span class="file-size">{{ file.size }}</span>
                                    <el-button 
                                        type="primary" 
                                        size="mini"
                                        icon="el-icon-download"
                                        @click.stop="downloadFile(file)"
                                        :disabled="!isVip"
                                    >
                                        {{ isVip ? '下载' : '购买后下载' }}
                                    </el-button>
                                </div>
                            </div>

                            <!-- 文件预览/下载区域（精致版） -->
                            <div class="file-preview-area" v-if="currentFile">
                                <div class="preview-header">
                                    <h4 class="preview-title">
                                        {{ currentFile.type === 'pdf' || currentFile.type === 'image' ? '文件预览' : '文件下载' }}
                                    </h4>
                                    <span class="file-name">【{{ currentFile.name }}】</span>
                                </div>
                                <div class="preview-content" v-if="currentFile.type === 'pdf'">
                                    <div class="preview-limit" v-if="!isVip">
                                        <i class="el-icon-vip"></i>
                                        <p>未购买用户无法预览完整PDF</p>
                                        <el-button type="primary" @click="goVipPage">购买后解锁</el-button>
                                    </div>
                                    <div class="pdf-preview" v-else>
                                        <embed :src="resourceUrl + currentFile.urls" type="application/pdf" width="100%" height="500px">
                                    </div>
                                </div>
                                <div class="preview-content" v-else-if="currentFile.type === 'image'">
                                    <div class="preview-limit" v-if="!isVip">
                                        <i class="el-icon-vip"></i>
                                        <p>未购买用户无法预览高清图片</p>
                                        <el-button type="primary" @click="goVipPage">购买后解锁</el-button>
                                    </div>
                                    <div class="img-preview" v-else>
                                        <img :src="resourceUrl + currentFile.urls" :alt="currentFile.name" class="preview-img">
                                    </div>
                                </div>
                                <div class="preview-content" v-else>
                                    <div class="preview-limit" v-if="!isVip">
                                        <i class="el-icon-vip"></i>
                                        <p>购买后才能下载文件</p>
                                        <el-button type="primary" @click="goVipPage">购买后解锁</el-button>
                                    </div>
                                    <div class="file-preview" v-else>
                                        <i :class="getFileIcon(currentFile.type)"></i>
                                        <div class="file-info">
                                            <p>文件类型：{{ currentFile.type.toUpperCase() }}</p>
                                            <p>更新时间：{{ currentFile.update_do }}</p>
                                        </div>
                                        <el-button type="primary" icon="el-icon-download" @click="downloadFile(currentFile)">
                                            立即下载
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 右侧：推荐侧边栏 -->
                        <div class="file-right">
                            <div class="recommend-sidebar">
                                <h3 class="recommend-title">
                                    <i class="el-icon-star-on"></i> 相关课程推荐
                                </h3>
                                <div class="empty-state" v-if="!recommendCourses || recommendCourses.length === 0">
                                    <i class="el-icon-star-off"></i>
                                    <p>暂无推荐课程</p>
                                </div>
                                <div 
                                    class="recommend-item" 
                                    v-for="item in recommendCourses" 
                                    :key="item.id"
                                    @click="goCourseDetail(item.id)"
                                >
                                    <img 
                                        :src="resourceUrl + item.cover" 
                                        :alt="item.name" 
                                        class="recommend-cover"
                                        @error="handleCoverError($event)"
                                    >
                                    <div class="recommend-info">
                                        <h4 class="recommend-name" :title="item.name">{{ item.name || '-' }}</h4>
                                        <p class="recommend-meta">
                                            <span class="meta-teacher"><i class="el-icon-user"></i>{{ item.author_name || '讲师' }}</span>
                                            <span class="meta-count"><i class="el-icon-view"></i>{{ item.looks || 0 }}</span>
                                        </p>
                                    </div>
                                </div>
                                <el-button type="text" class="more-btn" @click="goRecommendList">查看更多 ></el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>

        <!-- 公共底部 -->
        <FooterPc />
    </div>
</template>

<script>
// 适配实际路径引入公共组件
import HeaderPc from '@/components/pc/header.vue';
import FooterPc from '@/components/pc/fotter.vue';
import { getCourse, dolCollect  } from '@/api/home';
import { Session } from '@/utils/storage';

export default {
    name: 'CourseDetail',
    components: {
        HeaderPc,
        FooterPc
    },
    props: {
        id: {
            type: [String, Number],
            required: true
        }
    },
    data() {
        return {
            // 课程类型：video-纯视频，file-纯资料
            courseType: 'video',
            // 系统资源地址
            resourceUrl: process.env.VUE_APP_STATIC_URL,
            // VIP状态
            isVip: false,
            // 视频核心参数
            currentVideo: {},
            videoPaused: true,
            isMuted: false,
            playbackSpeed: 1,
            speedOptions: [0.5, 0.75, 1, 1.25, 1.5, 2],
            showSpeedOptions: false,
            currentTime: 0,
            totalTime: 0,
            loadedPercent: 0,
            currentPercent: 0,
            watchLimitReached: false,
            // 二维码悬浮层
            showQrCode: false,
            // 全屏状态
            isFullscreen: false,
            // 播放器尺寸模式: normal-普通, small-小屏, wide-宽屏
            playerSize: 'normal',
            // 激活的Tab
            activeTab: 'intro',

            // 视频课程数据
            classList: [],
            courseInfo: {},
            author: {},
            chapterList: [],
            recommendCourses: [],
            currentFile: null
        }
    },
    created() {
        // 获取课程详情
        this.fetchCourseDetail()
    },
    watch: {
        '$route.params.id': {
            handler(newId) {
                if (newId) {
                    this.fetchCourseDetail()
                }
            },
            immediate: false
        }
    },
    mounted() {
        // 初始化视频播放器
        this.$nextTick(() => {
            this.initVideoPlayer()
        })
    },
    methods: {
        fetchCourseDetail(){
            const courseId = this.id || this.$route.params.id
            const chapterId = this.$route.query.chapter_id
            getCourse(courseId).then(res=>{
                if(res.code){
                    // 基础课程信息
                    this.courseInfo = res.data.course || {}
                    this.author = res.data.author || {}
                    this.classList = res.data.classes || []
                    
                    // 判断是否VIP或已购买
                    this.isVip = this.courseInfo.is_buy === 1 || this.courseInfo.is_free === 1
                    
                    // 设置当前视频
                    if(this.classList.length > 0){
                        // 如果有章节ID参数，尝试找到对应章节
                        if(chapterId){
                            const targetChapter = this.classList.find(item => item.id == chapterId)
                            this.currentVideo = targetChapter || this.classList[0]
                        } else {
                            this.currentVideo = this.classList[0]
                        }
                    }
                    
                    // 处理章节列表（从classList生成）
                    this.generateChapterList()
                    
                    // 获取推荐课程
                    this.recommendCourses = res.data.recommend || []

                    this.courseType = this.courseInfo.ctype == 2 ? 'file' : 'video'
                }else{
                    this.$message.error(res.msg || '获取课程详情失败') 
                }
            }).catch(error=>{
                console.error('获取课程详情失败：', error)
                this.$message.error('获取课程详情失败，请稍后重试')
                setTimeout(()=>{
                    this.$router.go(-1)
                },1000)
            })
        },
        // 生成章节列表（从classList转换）
        generateChapterList(){
            if(!this.classList || this.classList.length === 0) return
            
            // 按章节分组（假设classList中有chapter_id或chapter_name字段）
            const chapterMap = {}
            this.classList.forEach((item, index) => {
                const chapterId = item.chapter_id || 1
                const chapterName = item.chapter_name || '默认章节'
                
                if(!chapterMap[chapterId]){
                    chapterMap[chapterId] = {
                        id: chapterId,
                        name: chapterName,
                        lessons: []
                    }
                }
                
                chapterMap[chapterId].lessons.push({
                    id: item.id,
                    name: item.name,
                    videoId: item.id,
                    duration: item.duration || '00:00'
                })
            })
            
            this.chapterList = Object.values(chapterMap)
        },
        // 初始化视频播放器
        initVideoPlayer() {
            const video = this.$refs.videoPlayer
            if (!video) return
            // 绑定事件
            video.addEventListener('progress', () => {
                if (video.buffered.length > 0) {
                    const loaded = video.buffered.end(0) / video.duration
                    this.loadedPercent = Math.floor(loaded * 100)
                }
            })
        },
        // 切换播放/暂停
        toggleVideoPlay() {
            const video = this.$refs.videoPlayer
            if (!video) return

            if (this.watchLimitReached && !this.isVip) {
                this.$message.warning('试看时间已结束，请付费后继续观看')
                return
            }

            video.paused ? video.play() : video.pause()
        },
        // 切换静音
        toggleMute() {
            const video = this.$refs.videoPlayer
            if (!video) return
            this.isMuted = !this.isMuted
            video.muted = this.isMuted
        },
        // 设置播放倍速
        setPlaybackSpeed(speed) {
            const video = this.$refs.videoPlayer
            if (!video) return
            this.playbackSpeed = speed
            video.playbackRate = speed
            this.showSpeedOptions = false
        },
        // 切换画中画
        async togglePictureInPicture() {
            const video = this.$refs.videoPlayer
            if (!video) return
            
            try {
                if (document.pictureInPictureElement) {
                    await document.exitPictureInPicture()
                } else if (document.pictureInPictureEnabled) {
                    await video.requestPictureInPicture()
                }
            } catch (error) {
                console.error('画中画失败:', error)
                this.$message.error('浏览器不支持画中画功能')
            }
        },
        // 切换全屏
        toggleFullscreen() {
            const container = this.$refs.videoPlayer?.parentElement
            if (!container) return
            
            if (!this.isFullscreen) {
                if (container.requestFullscreen) {
                    container.requestFullscreen()
                } else if (container.webkitRequestFullscreen) {
                    container.webkitRequestFullscreen()
                } else if (container.mozRequestFullScreen) {
                    container.mozRequestFullScreen()
                } else if (container.msRequestFullscreen) {
                    container.msRequestFullscreen()
                }
                this.isFullscreen = true
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen()
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen()
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen()
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen()
                }
                this.isFullscreen = false
            }
        },
        // 时间更新
        handleTimeUpdate() {
            const video = this.$refs.videoPlayer
            if (!video || !video.duration) return

            this.currentTime = video.currentTime
            this.totalTime = video.duration
            this.currentPercent = Math.floor((this.currentTime / this.totalTime) * 100)

            // 非VIP试看限制（根据课程设置）
            if (!this.isVip && this.courseInfo.is_preview) {
                const previewSeconds = (this.courseInfo.preview_hours || 0) * 3600 + 
                                      (this.courseInfo.preview_mins || 0) * 60 + 
                                      (this.courseInfo.preview_seconds || 0)
                if (previewSeconds > 0 && this.currentTime >= previewSeconds) {
                    video.pause()
                    this.watchLimitReached = true
                }
            }
        },
        // 加载完成获取总时长
        handleLoadedMetadata() {
            const video = this.$refs.videoPlayer
            if (!video) return
            this.totalTime = video.duration
        },
        // 点击进度条跳转
        handleProgressClick(e) {
            const video = this.$refs.videoPlayer
            if (!video || !video.duration || (this.watchLimitReached && !this.isVip)) return

            const progressBar = e.currentTarget
            const clickX = e.offsetX
            const percent = clickX / progressBar.offsetWidth
            const targetTime = percent * video.duration

            // 非VIP试看限制
            if (!this.isVip && this.courseInfo.is_preview) {
                const previewSeconds = (this.courseInfo.preview_hours || 0) * 3600 + 
                                      (this.courseInfo.preview_mins || 0) * 60 + 
                                      (this.courseInfo.preview_seconds || 0)
                if (previewSeconds > 0 && targetTime >= previewSeconds) {
                    video.currentTime = previewSeconds
                    this.currentTime = previewSeconds
                    this.currentPercent = Math.floor((previewSeconds / video.duration) * 100)
                    video.pause()
                    this.watchLimitReached = true
                    this.$message.warning('试看时间已结束，请开通VIP继续观看')
                    return
                }
            }

            video.currentTime = targetTime
            this.currentTime = targetTime
            this.currentPercent = Math.floor(percent * 100)
        },
        // 切换视频
        switchVideo(item) {
            this.currentVideo = item
            this.watchLimitReached = false
            this.videoPaused = true
            this.currentTime = 0
            this.currentPercent = 0
            this.$nextTick(() => {
                const video = this.$refs.videoPlayer
                if (video) {
                    video.currentTime = 0
                    video.load()
                }
            })
        },
        // 播放章节对应视频
        playLessonVideo(videoId) {
            const targetVideo = this.classList.find(item => item.id === videoId)
            if (targetVideo) {
                this.switchVideo(targetVideo)
                // 滚动到视频播放器
                this.$nextTick(() => {
                    const videoPlayer = this.$refs.videoPlayer
                    if(videoPlayer){
                        videoPlayer.scrollIntoView({ behavior: 'smooth', block: 'start' })
                    }
                })
            }
        },
        // 格式化时间 秒 -> 分:秒
        formatTime(seconds) {
            if (!seconds) return '00:00'
            const min = Math.floor(seconds / 60)
            const sec = Math.floor(seconds % 60)
            return `${min.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`
        },
        // 格式化时长显示
        formatDuration(duration) {
            if (!duration) return '00:00'
            // 如果已经是格式化的字符串，直接返回
            if (typeof duration === 'string' && duration.includes(':')) {
                return duration
            }
            // 如果是秒数，转换为分:秒
            return this.formatTime(duration)
        },
        // 文件图标映射
        getFileIcon(type) {
            const iconMap = {
                pdf: 'fa fa-file-pdf',
                image: 'fa fa-file-image',
                zip: 'fa fa-file-archive',
                rar: 'fa fa-file-archive',
                doc: 'fa fa-file-word',
                docx: 'fa fa-file-word',
                xlsx: 'fa fa-file-excel',
                xls: 'fa fa-file-excel',
                ppt: 'fa fa-file-powerpoint',
                pptx: 'fa fa-file-powerpoint',
                txt: 'fa-regular fa-file',
                mp3: 'fa-regular fa-file-audio',
                mp4: 'fa-regular fa-file-video',
                avi: 'fa-regular fa-file-video',
                mov: 'fa-regular fa-file-video',
                audio: 'fa-regular fa-file-audio',
            }
            return iconMap[type] || 'fa-regular fa-file'
        },
        // 点击文件
        handleFileClick(file) {
            this.currentFile = file
        },
        // 下载文件
        downloadFile(file) {
            if (!this.isVip) {
                this.$message.warning('未购买用户无法下载，请先购买课程')
                return
            }
            if (!file.urls) {
                this.$message.error('文件地址不存在')
                return
            }
            this.$message.success(`开始下载：${file.name}`)
            const link = document.createElement('a')
            link.href = this.resourceUrl + file.urls
            link.download = file.name
            link.target = '_blank'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        },
        // 二维码加载失败兜底
        handleQrError(e) {
            e.target.src = ''
        },
        // 封面图加载失败兜底
        handleCoverError(e) {
            e.target.src = ''
        },
        // 跳转课程详情
        goCourseDetail(id) {
            if (this.$route.params.id == id) {
                return
            }
            this.$router.push(`/course/${id}`)
        },
        // 跳转VIP开通页
        goVipPage() {
            // 检查是否登录
            const token = Session.get('token')
            if (!token) {
                this.$message.warning('请先登录')
                // 递归查找 HeaderPc 组件
                const findHeaderComponent = (component) => {
                    if (component.$options.name === 'HeaderPc') {
                        return component
                    }
                    if (component.$children && component.$children.length > 0) {
                        for (let child of component.$children) {
                            const found = findHeaderComponent(child)
                            if (found) return found
                        }
                    }
                    return null
                }
                
                const headerComponent = findHeaderComponent(this.$root)
                if (headerComponent && typeof headerComponent.handleShowLogin === 'function') {
                    headerComponent.handleShowLogin()
                } else {
                    console.error('HeaderPc 组件或 handleShowLogin 方法未找到')
                }
                return
            }
            let id = this.$route.params.id
            this.$router.push('/pay?course_id=' + id)
        },
        // 跳转推荐列表
        goRecommendList() {
            this.$router.push('/category')
        },
        // 切换收藏状态
        toggleCollect() {
            let token = Session.get('token')
            if (!token) {
                this.$message.warning('请先登录')
                return
            }
            
            let courseId = this.$route.params.id
            
            dolCollect({ id: courseId }).then(res => {
                if (res.code) {
                    this.courseInfo.is_collect = !this.courseInfo.is_collect
                    this.$message.success(this.courseInfo.is_collect ? '收藏成功' : '取消收藏成功')
                } else {
                    this.$message.error(res.msg || '操作失败')
                }
            }).catch(() => {
                this.$message.error('操作失败，请稍后重试')
            })
        }
    }
}
</script>

<style scoped>
.course-detail-page {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: #f5f7fa;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
}

/* 标题栏样式（精致版） */
.course-title-bar {
    background: #fff;
    border-bottom: 1px solid #e5e7eb;
    padding: 24px 0;
    margin-bottom: 24px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
}
.course-title-bar .container {
    width: 90%;
    margin: 0 auto;
}
.title-bar-content {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 20px;
}
.title-left {
    flex: 1;
}
.title-right {
    flex-shrink: 0;
}
.main-title {
    font-size: 26px;
    font-weight: 600;
    color: #1f2937;
    margin: 0 0 16px 0;
    line-height: 1.4;
}
.course-meta-group {
    display: flex;
    gap: 28px;
    font-size: 14px;
    color: #666;
    flex-wrap: wrap;
}
.meta-item {
    display: flex;
    align-items: center;
}
.meta-item i {
    color: #1890ff;
    margin-right: 8px;
    font-size: 16px;
}
.vip-tag {
    color: #f56c6c !important;
    background-color: #fff2f2;
    padding: 4px 12px;
    border-radius: 4px;
}

.course-main {
    flex: 1;
    padding: 0 0 40px 0;
}
.container {
    width: 90%;
    margin: 0 auto;
}

/* 纯视频课程样式（精致版） */
.video-course-wrap {
    width: 100%;
}
.video-player-section {
    display: flex;
    gap: 24px;
    background: #fff;
    padding: 24px;
    border-radius: 12px;
    margin-bottom: 24px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
}
/* 视频播放器容器 */
.video-player {
    flex: 3;
    height: 500px;
    border-radius: 8px;
    position: relative;
    overflow: hidden;
    transition: all 0.3s ease;
}
/* 宽屏模式 */
.video-player-section.wide .video-player {
    flex: 1;
    width: 100%;
}
.video-container {
    width: 100%;
    height: 100%;
    position: relative;
}
.video-core {
    width: 100%;
    height: 100%;
    object-fit: cover;
    background-color: #000;
}

/* 视频控制栏（优化版） */
.video-controls {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 12px 20px;
    background: linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.7) 50%, transparent 100%);
    display: flex;
    align-items: center;
    gap: 12px;
    z-index: 9;
}
.control-btn {
    min-width: 32px;
    height: 32px;
    padding: 0 10px;
    border-radius: 4px;
    background: rgba(255,255,255,0.15);
    border: none;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    transition: all 0.2s ease;
}
.control-btn:hover {
    background: rgba(255,255,255,0.25);
}
.control-btn i {
    font-size: 16px;
}

/* 播放按钮特殊样式 */
.play-btn {
    width: 32px;
    padding: 0;
}
.play-btn i {
    font-size: 18px;
}

/* 倍速按钮特殊样式 */
.speed-btn {
    position: relative;
    min-width: 50px;
}
.speed-btn .speed-text {
    font-size: 13px;
    font-weight: 500;
}

/* 新增：手机按钮专属样式 */
.phone-btn {
    position: relative;
}

/* 进度条样式 */
.progress-wrap {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
}
.progress-bar {
    height: 4px;
    background: rgba(255,255,255,0.2);
    border-radius: 2px;
    position: relative;
    cursor: pointer;
}
.progress-loaded {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background: rgba(255,255,255,0.4);
    border-radius: 2px;
}
.progress-current {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background: #1890ff;
    border-radius: 2px;
}
.progress-dot {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 12px;
    height: 12px;
    background: #1890ff;
    border-radius: 50%;
    box-shadow: 0 0 8px rgba(24, 144, 255, 0.5);
}
.time-wrap {
    display: flex;
    gap: 8px;
    color: #fff;
    font-size: 12px;
}

/* 倍速选择样式（美化版） */
.control-group {
    display: flex;
    align-items: center;
    gap: 8px;
}
.speed-options {
    position: absolute;
    bottom: 42px;
    left: 50%;
    transform: translateX(-50%);
    background: linear-gradient(135deg, rgba(20,20,20,0.98) 0%, rgba(40,40,40,0.98) 100%);
    border-radius: 10px;
    padding: 10px 6px;
    display: flex;
    flex-direction: column-reverse;
    gap: 6px;
    z-index: 99;
    box-shadow: 0 8px 24px rgba(0,0,0,0.5), 0 0 1px rgba(255,255,255,0.1) inset;
    border: 1px solid rgba(255,255,255,0.08);
    backdrop-filter: blur(10px);
    animation: speedFadeIn 0.2s ease;
}
@keyframes speedFadeIn {
    from {
        opacity: 0;
        transform: translateX(-50%) translateY(5px);
    }
    to {
        opacity: 1;
        transform: translateX(-50%) translateY(0);
    }
}
.speed-options::before {
    content: '';
    position: absolute;
    bottom: -6px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid rgba(20,20,20,0.98);
}
.speed-option {
    padding: 8px 20px;
    font-size: 13px;
    font-weight: 500;
    border-radius: 6px;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    text-align: center;
    cursor: pointer;
    white-space: nowrap;
    color: rgba(255,255,255,0.75);
    position: relative;
    overflow: hidden;
}
.speed-option::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.1), transparent);
    transition: left 0.5s;
}
.speed-option:hover::before {
    left: 100%;
}
.speed-option:hover {
    background: rgba(255,255,255,0.12);
    color: #fff;
    transform: translateX(2px);
    box-shadow: 0 2px 8px rgba(24,144,255,0.2);
}
.speed-option.active {
    background: linear-gradient(135deg, #1890ff 0%, #40a9ff 100%);
    color: #fff;
    box-shadow: 0 4px 12px rgba(24,144,255,0.4), 0 0 0 1px rgba(255,255,255,0.2) inset;
    font-weight: 600;
    transform: scale(1.05);
}
.speed-option.active::after {
    content: '✓';
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 12px;
    opacity: 0.9;
}

/* 二维码悬浮层（优化：定位到手机按钮旁） */
.qr-code-layer {
    position: absolute;
    bottom: 70px;
    right: 0;
    z-index: 10;
    /* 防止二维码超出容器 */
    transform: translateX(-8%);
}
.qr-card {
    width: 180px;
    background: #fff;
    border-radius: 12px;
    padding: 16px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    text-align: center;
    /* 加个小三角指向手机按钮 */
    position: relative;
}
.qr-card::after {
    content: '';
    position: absolute;
    bottom: -8px;
    right: 20px;
    width: 16px;
    height: 16px;
    background: #fff;
    transform: rotate(45deg);
    box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.1);
}
.qr-header {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-bottom: 12px;
    font-size: 14px;
    color: #333;
    font-weight: 500;
}
.qr-header i {
    color: #1890ff;
}
.qr-img {
    width: 120px;
    height: 120px;
    border-radius: 8px;
}
.qr-tip {
    margin-top: 12px;
    font-size: 12px;
    color: #94a3b8;
}

/* 试看结束遮罩样式 */
.watch-limit-mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 5;
}
.limit-card {
    width: 320px;
    background: #fff;
    border-radius: 12px;
    padding: 32px;
    text-align: center;
}
.limit-card i {
    font-size: 48px;
    color: #f56c6c;
    margin-bottom: 16px;
}
.limit-card h3 {
    font-size: 18px;
    color: #333;
    margin-bottom: 8px;
}
.limit-card p {
    font-size: 14px;
    color: #666;
    margin-bottom: 24px;
}

/* 视频列表（精致版） */
.video-list {
    flex: 1;
    max-height: 500px;
    overflow-y: auto;
    padding: 8px;
}
/* 空状态样式 */
.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    color: #94a3b8;
}
.empty-state i {
    font-size: 64px;
    color: #d1d5db;
    margin-bottom: 16px;
}
.empty-state p {
    font-size: 14px;
    color: #94a3b8;
}
.video-list::-webkit-scrollbar {
    width: 4px;
}
.video-list::-webkit-scrollbar-track {
    background: #f5f7fa;
    border-radius: 2px;
}
.video-list::-webkit-scrollbar-thumb {
    background: #d9d9d9;
    border-radius: 2px;
}
.list-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
}
.list-title .count {
    font-size: 12px;
    color: #94a3b8;
    font-weight: 400;
}
.video-item {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    border-radius: 8px;
    cursor: pointer;
    margin-bottom: 8px;
    background: #f8fafc;
    transition: all 0.2s ease;
    position: relative;
}
.video-item.active {
    background: #e6f7ff;
    border-left: 3px solid #1890ff;
}
.video-item:hover {
    background: #e5e7eb;
}
.video-index {
    width: 28px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    background: #1890ff;
    color: #fff;
    border-radius: 50%;
    margin-right: 12px;
    font-size: 12px;
}
.video-name {
    flex: 1;
    font-size: 14px;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.video-duration {
    font-size: 12px;
    color: #94a3b8;
    margin-right: 16px;
}
.try-watch-tag {
    font-size: 10px;
    color: #f56c6c;
    background: #fff2f2;
    padding: 2px 6px;
    border-radius: 4px;
    position: absolute;
    right: 16px;
}

/* 视频课程Tab + 推荐侧边栏（精致版） */
.course-info-section {
    display: flex;
    gap: 24px;
    background: #fff;
    padding: 24px;
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
}
.course-tabs {
    flex: 3;
}
.course-tabs ::v-deep .el-tabs__header {
    margin-bottom: 24px;
}
.course-tabs ::v-deep .el-tabs__item {
    font-size: 16px;
    padding: 0 20px;
}
.course-tabs ::v-deep .el-tabs__active-bar {
    background-color: #1890ff;
}
.tab-content {
    font-size: 14px;
    color: #666;
}
.content-title {
    font-size: 18px;
    color: #333;
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f0f0f0;
}
.intro-content .intro-main {
    display: flex;
    gap: 24px;
    margin-bottom: 24px;
}
.intro-left .course-cover {
    width: 200px;
    height: 120px;
    object-fit: cover;
    border-radius: 8px;
}
.intro-right {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 12px;
}
.intro-right .tag {
    display: inline-block;
    padding: 4px 12px;
    background: #f0f7ff;
    color: #1890ff;
    border-radius: 4px;
    margin-right: 8px;
    margin-bottom: 8px;
}
.intro-desc {
    line-height: 1.8;
}
.intro-desc h4 {
    font-size: 16px;
    color: #333;
    margin-bottom: 12px;
}
.chapter-content .el-collapse-item {
    margin-bottom: 8px;
}
.chapter-content .el-collapse-item__header {
    font-size: 14px;
    color: #333;
}
.chapter-item {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    border-radius: 8px;
    margin-bottom: 8px;
    background: #f8fafc;
    cursor: pointer;
    transition: all 0.2s ease;
}
.chapter-item:hover {
    background: #e6f7ff;
}
.chapter-item.active-lesson {
    background: #e6f7ff;
    border-left: 3px solid #1890ff;
}
.chapter-item i {
    color: #1890ff;
    margin-right: 12px;
}
.chapter-item .lesson-name {
    flex: 1;
}
.chapter-item .lesson-duration {
    font-size: 12px;
    color: #94a3b8;
    margin-right: 16px;
}
.chapter-item .try-tag {
    font-size: 10px;
    color: #f56c6c;
    background: #fff2f2;
    padding: 2px 6px;
    border-radius: 4px;
}

/* 课程推荐侧边栏（精致版） */
.recommend-sidebar {
    flex: 1;
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    max-height: 600px;
    overflow-y: auto;
}
.recommend-sidebar::-webkit-scrollbar {
    width: 4px;
}
.recommend-sidebar::-webkit-scrollbar-thumb {
    background: #d9d9d9;
    border-radius: 2px;
}
.recommend-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 2px solid #f0f0f0;
    display: flex;
    align-items: center;
    gap: 8px;
}
.recommend-title i {
    color: #faad14;
    font-size: 18px;
}
.recommend-item {
    display: flex;
    gap: 12px;
    padding: 12px;
    border-radius: 8px;
    background: #fafafa;
    margin-bottom: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
    border: 1px solid transparent;
}
.recommend-item:hover {
    background: #f0f7ff;
    border-color: #1890ff;
    transform: translateX(4px);
    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.15);
}
.recommend-cover {
    width: 100px;
    height: 60px;
    object-fit: cover;
    border-radius: 6px;
    flex-shrink: 0;
}
.recommend-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 0;
}
.recommend-name {
    font-size: 14px;
    font-weight: 500;
    color: #333;
    margin: 0 0 8px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 1.4;
}
.recommend-item:hover .recommend-name {
    color: #1890ff;
}
.recommend-teacher {
    font-size: 12px;
    color: #666;
    margin-bottom: 4px;
}
.recommend-stats {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: #94a3b8;
}
.recommend-stats span {
    display: flex;
    align-items: center;
    gap: 4px;
}
.recommend-stats i {
    font-size: 12px;
}
.recommend-meta {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: #94a3b8;
}
.recommend-meta i {
    margin-right: 4px;
    font-size: 12px;
}
.meta-teacher,
.meta-count {
    display: flex;
    align-items: center;
}
.more-btn {
    width: 100%;
    color: #1890ff;
    font-size: 14px;
    margin-top: 8px;
}

/* 纯资料课程样式（精致版） */
.file-course-wrap {
    width: 100%;
}
.file-course-content {
    display: flex;
    gap: 24px;
}
.file-left {
    flex: 3;
    background: #fff;
    padding: 24px;
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
}
.file-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
}
.file-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    gap: 8px;
}
.file-title .count {
    font-size: 14px;
    color: #94a3b8;
    font-weight: 400;
}
.file-list {
    margin-bottom: 32px;
}
.file-item {
    display: flex;
    align-items: center;
    padding: 16px;
    border-bottom: 1px solid #f0f0f0;
    font-size: 14px;
}
.file-item:last-child {
    border-bottom: none;
}
.file-item i {
    font-size: 24px;
    color: #1890ff;
    margin-right: 16px;
}
.file-name {
    flex: 1;
    color: #333;
}
.file-size {
    font-size: 12px;
    color: #94a3b8;
    margin-right: 16px;
}
.file-preview-area {
    background: #f8fafc;
    border-radius: 8px;
    padding: 24px;
}
.preview-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
}
.preview-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
}
.preview-content {
    min-height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    border-radius: 8px;
    padding: 24px;
}
.preview-limit {
    text-align: center;
}
.preview-limit i {
    font-size: 64px;
    color: #f56c6c;
    margin-bottom: 16px;
}
.preview-limit p {
    font-size: 14px;
    color: #666;
    margin-bottom: 24px;
}
.pdf-preview {
    width: 100%;
    height: 500px;
}
.img-preview .preview-img {
    max-width: 100%;
    max-height: 500px;
    border-radius: 8px;
}
.file-preview {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}
.file-preview i {
    font-size: 64px;
    color: #1890ff;
    margin-bottom: 16px;
}
.file-info {
    margin-bottom: 24px;
}
.file-info p {
    font-size: 14px;
    color: #666;
    margin-bottom: 8px;
}

/* 资料推荐侧边栏（精致版） */
.file-right {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 24px;
}
.recommend-block {
    background: #fff;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
}

/* 响应式适配（精致版） */
@media (max-width: 1280px) {
    .container {
        width: 90%;
    }
    .video-player-section {
        flex-direction: column;
    }
    .video-player {
        height: 400px;
    }
    .video-list {
        max-height: 200px;
    }
    .course-info-section {
        flex-direction: column;
    }
    .file-course-content {
        flex-direction: column;
    }
}
@media (max-width: 768px) {
    .video-player {
        height: 300px;
    }
    .video-controls {
        padding: 12px 16px;
        gap: 8px;
    }
    .control-btn {
        width: 32px;
        height: 32px;
    }
    .main-title {
        font-size: 22px;
    }
    .course-meta-group {
        gap: 16px;
    }
}
</style>